import React from 'react';
import {
  ContactType,
  ClientContactTag,
  SupplierContactTag,
  IClientContact,
  ISupplierContact,
} from '@bb/contacts';

import { ALL_CONTACT_TAGS } from 'components';

import { buildFullName, buildListingFullAddress } from 'utils';
import ContactItemLayout from './ContactItemLayout';

type ContactItemProps = {
  contact: IClientContact | ISupplierContact;
};

const isClientType = (
  contact: IClientContact | ISupplierContact,
): contact is IClientContact => contact.type === ContactType.Client;

const ContactItem: React.FC<ContactItemProps> = ({ contact }) => {
  const { firstName, lastName = '' } = contact;
  const fullName = buildFullName(firstName, lastName);

  let subTextOne: string;
  if (isClientType(contact)) {
    if (typeof contact.address === 'string') {
      subTextOne = contact.address;
    } else if (contact.address) {
      subTextOne = buildListingFullAddress(
        contact.address.line1,
        contact.address.line2,
      );
    }
  } else {
    subTextOne = contact.companyName;
  }

  const avatarUser = {
    firstName,
    lastName,
  };

  return (
    <ContactItemLayout
      avatarUser={avatarUser}
      mainText={fullName}
      subTextOne={subTextOne}
      subTextTwo={(contact.tags as (ClientContactTag | SupplierContactTag)[])
        .map(tag => ALL_CONTACT_TAGS[tag].label)
        .join(', ')}
    />
  );
};

export default ContactItem;
